import React from "react";
// import logo from "../../../public/logo192.png"

const Loader = () => {
  return (
    <div className="preloader" id="preloader">
      <div className="loader">
       <img  src={`${process.env.PUBLIC_URL}/logo192.png`}  alt="loader"/>
      </div>
    </div>
  );
};

export default Loader;
